import React from "react";

const FormTabSwitcher = ({ tabs, currentTab, onTabChange }) => {
  const handleTabStyle = (tabName) => {
    return tabName === currentTab
      ? "text-dark-blue border-dark-blue"
      : "text-gray-600 border-transparent hover:text-dark-blue transition";
  };

  return (
    <div className="flex space-x-4 border-b border-lg5">
      {tabs.map((tab) => (
        <button
          key={tab.name}
          className={`${handleTabStyle(tab.name)} cylinder-tab-button`}
          onClick={() => onTabChange(tab.name)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default FormTabSwitcher;
